<template lang="">
    <div class="container">
        <v-card>
            <v-card-text>
                <v-card-title class="titulopagina">MENUS / ROLES</v-card-title>
            </v-card-text>

            <v-tabs
                fixed-tabs
                background-color="cyan darken-3"
                dark
                v-model="tabs"
            >
            <v-tabs-slider color="yellow"></v-tabs-slider>
                <v-tab key="menus">
                    <v-card-title>
                        MENÚS
                    </v-card-title>
                </v-tab>
                <v-tab key="users">
                    <v-card-title>
                        USUARIOS
                    </v-card-title>
                </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tabs">
                <v-tab-item key="menus">
                    <tab-menus :roles="roles" :can_manipulate="can_manipulate" @abrir_modal_create="abrirModalCreate" ref="tabMenus"></tab-menus>
                </v-tab-item>

                <v-tab-item key="users">
                    <tab-usuarios :roles="roles" :can_manipulate="can_manipulate" @abrir_modal_user_roles="abrirModalUsuario" ref="tabUsuarios"></tab-usuarios>
                </v-tab-item>
            </v-tabs-items>

        </v-card>
        <modal-create @cargar_menus="cargarMenus"></modal-create>
        <modal-usuarios @cargar_usuarios="cargarUsuarios" ref="modalUsuarios"></modal-usuarios>
        <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import ConfirmDialogue from '@/components/ConfirmDialogue.vue'

// Modal Create
import ModalMenus from './ModalMenus.vue';
import ModalUsuarios from './ModalUsuarios.vue';

// Tabs
import TabUsuarios from './TabUsuarios.vue';
import TabMenus from './TabMenus.vue';

export default {
    data: () => ({
        tabs: null,
        roles: [],
        can_manipulate: false,
    }),
    mounted() {
        this.cargarRoles();
    },
    methods: {
        async cargarRoles() {
            this.mostrarLoading({ titulo: "Cargando roles...", color: "green" })
            const url = `${this.base_url}roles`;
            await this.axios.get(url, this.headers).then(res => {
                console.log({ res_roles: res.data.data });
                this.roles = res.data.data.roles;

                let user_roles = res.data.data.user_roles;
                // Agregar roles en caso de que alguno más pudiera crear o modificar roles de menús y usuarios;
                const roles_enabled = ['Admin'];
                this.can_manipulate = user_roles.some(role => roles_enabled.includes(role.name));

                this.ocultarLoading();
            }).catch(error => {
                console.error('error', error);
                this.errorMessage(error, "Error al cargar roles");
            });
        },
        abrirModalCreate(item = null) {
            if(item) {
                this.$emit('abrir_modal_create', [this.roles, item]);
            } else {
                this.$emit('abrir_modal_create', [this.roles]);
            }
        },
        cargarMenus() {
            this.$refs.tabMenus.cargarMenus();
        },
        abrirModalUsuario(datos) {
            this.$refs.modalUsuarios.abrirModal(datos);
        },
        cargarUsuarios() {
            this.$refs.tabUsuarios.cargarUsuarios();
        },
        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        ...mapState(['base_url','headers']),
    },
    components: {
        "modal-create": ModalMenus,
        "modal-usuarios": ModalUsuarios,
        "tab-usuarios": TabUsuarios,
        "tab-menus": TabMenus,
        ConfirmDialogue,
    },
}
</script>

<style scoped>
</style>